module.exports = __webpack_public_path__ + "static/media/loading3.52a31037.gif";